import { getBusinesses } from '../../../data/repositories/businessRepository.js';
import { transformBusinessForMap } from './transformBusinessForMap.js';

export const searchBusinessesForMap = async (query, page = 1, take = 1000) => {
    const params = { page: String(page), take: String(take), name: query };
    const result = await getBusinesses(params);
    const businesses = result.data || [];
    return {
        businesses: businesses.map(transformBusinessForMap),
        hasNext: result.meta?.hasNext || false,
    };
};
